export function ownsQuoteLock(holdsLock, quoteLocked, userId) {
  if (holdsLock) {
    return true;
  }
  if (!quoteLocked || userId == null || quoteLocked.id == null) {
    return false;
  }
  return String(quoteLocked.id) === String(userId);
}

export function shouldUnlockOnBeforeUnload({
  hasUnsavedChanges,
  deleteQuote,
  lockedByOther,
}) {
  if (hasUnsavedChanges && !deleteQuote && !lockedByOther) {
    return false;
  }
  return true;
}

export function buildUnlockBeacon(apiBase, quoteId, userId) {
  if (!apiBase || !quoteId || quoteId === -1 || userId == null) {
    return null;
  }
  return {
    url: `${apiBase}/quote/unlock.php?id=${quoteId}`,
    body: new URLSearchParams({ user_id: String(userId) }),
  };
}
